var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 54,
    viewBox: "0 0 43 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0C15.7978 0 10.3292 2.2757 6.2972 6.32647C2.26517 10.3772 0 15.8713 0 21.5999C0 36.1799 18.9469 52.6498 19.7531 53.3518C20.2399 53.7701 20.8594 54 21.5 54C22.1406 54 22.7601 53.7701 23.2469 53.3518C24.1875 52.6498 43 36.1799 43 21.5999C43 15.8713 40.7348 10.3772 36.7028 6.32647C32.6708 2.2757 27.2022 0 21.5 0ZM21.5 47.6548C15.7756 42.2549 5.375 30.6179 5.375 21.5999C5.375 17.3034 7.07388 13.1829 10.0979 10.1448C13.1219 7.10676 17.2234 5.39998 21.5 5.39998C25.7766 5.39998 29.8781 7.10676 32.9021 10.1448C35.9261 13.1829 37.625 17.3034 37.625 21.5999C37.625 30.6179 27.2244 42.2819 21.5 47.6548ZM21.5 10.8C19.3739 10.8 17.2955 11.4334 15.5276 12.6201C13.7598 13.8068 12.3819 15.4935 11.5683 17.467C10.7547 19.4404 10.5418 21.6119 10.9566 23.7069C11.3713 25.8019 12.3952 27.7263 13.8986 29.2367C15.402 30.7471 17.3175 31.7757 19.4028 32.1924C21.4881 32.6091 23.6495 32.3952 25.6138 31.5778C27.5782 30.7604 29.2571 29.3761 30.4383 27.6001C31.6195 25.824 32.25 23.736 32.25 21.5999C32.25 18.7356 31.1174 15.9886 29.1014 13.9632C27.0854 11.9378 24.3511 10.8 21.5 10.8ZM21.5 26.9999C20.4369 26.9999 19.3977 26.6832 18.5138 26.0899C17.6299 25.4965 16.941 24.6531 16.5341 23.6664C16.1273 22.6797 16.0209 21.5939 16.2283 20.5464C16.4357 19.499 16.9476 18.5368 17.6993 17.7816C18.451 17.0264 19.4087 16.5121 20.4514 16.3037C21.494 16.0953 22.5748 16.2023 23.5569 16.611C24.5391 17.0197 25.3785 17.7118 25.9691 18.5999C26.5598 19.4879 26.875 20.5319 26.875 21.5999C26.875 23.0321 26.3087 24.4056 25.3007 25.4183C24.2927 26.431 22.9255 26.9999 21.5 26.9999Z",
    fill: "url(#paint0_linear_12_270)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_270",
    x1: 21.0401,
    y1: 41.58,
    x2: -15.6029,
    y2: 36.2141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ac9592c05cdd60c9237ea67860b27fc3.svg";
export { ForwardRef as ReactComponent };